
export default function PageTitle({ title }) {
  window.document.title = title;
  return null;
}
